module.exports = __webpack_public_path__ + "assets/warning-icon.svg";